export enum FilterSchema {
    basic = "http://powerbi.com/product/schema#basic",
    hierarchy = "http://powerbi.com/product/schema#hierarchy"
}